class Dropdown extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this._elements = {
        trigger: this.querySelector("[js-dropdown-trigger]"),
        menu: this.querySelector("[js-dropdown-menu]"),
        caret: this.querySelector("[js-dropdown-caret]"),
        optionName: this.querySelector("[js-option-name]"),
        items: this.querySelectorAll("[js-dropdown-item]"),
        select: this.querySelector('[js-dropdown-select]'),
      };
  
      this._elements.trigger.addEventListener('click', this.toggle);
  
      if (this._elements.select) {
        this._elements.items.forEach(item => {
          item.addEventListener('click', this.syncSelect)
        })
      }
  
      // Close on click outside
      document.addEventListener("click", (event) => {
        if (!this.contains(event.target)) this.close();
      });
    }
  
    syncSelect = (e) => {
      const value = e.currentTarget.dataset.value;
      const name = e.currentTarget.dataset.name;
      this._elements.select.value = value;
      this._elements.select.dispatchEvent(new InputEvent('input'));
      this._elements.select.dispatchEvent(new Event('change'));
      this._elements.optionName.textContent = name;
      this.close();
    }
  
    toggle = () => {
      if (this.isOpen()) {
        this.close();
      } else {
        this.open();
      }
    }
  
    isOpen = () => {
      return !this._elements.menu.classList.contains('hidden');
    }
  
    open = () => {
      this._elements.menu.classList.remove("hidden");
      this._elements.caret.classList.add('rotate-180');
      this._elements.trigger.setAttribute("aria-expanded", "true");
    };
  
    close = () => {
      this._elements.menu.classList.add("hidden");
      this._elements.caret.classList.remove('rotate-180');
      this._elements.trigger.setAttribute("aria-expanded", "false");
    };
  }
  customElements.define("s-dropdown", Dropdown);
